module.exports = __webpack_public_path__ + "img/cloud.a65ba0b5.svg";